import { Controller } from "@hotwired/stimulus"

// Abre solo el aviso de mails que no le llegaron al paciente.
//
// El cartel rojo de la ficha alcanza para quien lo mira, pero la ficha es larga
// y el punto de esta feature es que nadie se entere tarde. El modal se muestra
// en cada carga hasta que alguien lo marca como visto ("Ya lo vi"), que es lo
// que deja de traerlo en la próxima visita.
export default class extends Controller {
  connect() {
    // El modal se pinta con el resto de la ficha; se espera al siguiente tick
    // para que Bootstrap tenga el nodo montado.
    this.timeout = setTimeout(() => this.open(), 300)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  open() {
    if (typeof $ === "undefined") return

    $(this.element).modal("show")
  }
}
